import React, { useState } from "react";
import { 
  Box, 
  Fade, 
  Paper, 
  Popper, 
  Typography, 
  useTheme,
  ClickAwayListener
} from "@mui/material";
// import MilkCooler from "../../../../Assets/PNG/milk cooler.png";
import Thermization from "../../../../Assets/PNG/Thermization.png";

/**
 * Tooltip1 Material UI component - Milk Reception position
 * Maintains original positioning and functionality
 */
export const Tooltip3: React.FC = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState(false);

  // Styles matching original component
  const styles = {
    tooltipContainer: {
      // This maintains the original positioning from tooltip1 class
      position: 'absolute' as const,
    },
    tooltipButton: {
        position: 'fixed',
        left: '8%',
        top: '37%',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '1.2rem',
      fontWeight: 'bold',
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.3s ease',
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        transform: 'scale(1.1)',
      },
    },
    tooltipContent: {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[8],
      padding: 0,
      maxWidth: '700px',
      minWidth: '350px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'row',
    },
    tooltipImageContainer: {
      flex: '0 0 160px 0', // Fixed width for image
      height: '160px',
    },
    tooltipImage: {
      width: '100%',
      height: '100%',
      objectFit: 'cover' as const,
      display: 'block',
    },
     tooltipTextContent: {
      flex: 1,
      padding: theme.spacing(2),
      m: theme.spacing(2),
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    tooltipTitle: {
      fontSize: '1.1rem',
      fontWeight: 'bold',
      color: theme.palette.text.primary,
      marginBottom: theme.spacing(1),
      margin: 0,
    },
    tooltipParagraph: {
      fontSize: '0.875rem',
      lineHeight: 1.4,
      color: theme.palette.text.secondary,
      margin: 0,
    },
  };

  /**
   * Handle tooltip button click
   */
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(!open);
  };

  /**
   * Handle click away to close tooltip
   */
  const handleClickAway = () => {
    setOpen(false);
  };

  /**
   * Handle mouse enter for hover effect
   */
  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  /**
   * Handle mouse leave to close tooltip
   */
  const handleMouseLeave = () => {
    setOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={handleClickAway}>
      <Box 
        className="tooltip1 emelie-design--tooltip-1" // Maintain original positioning classes
        sx={styles.tooltipContainer}
      >
        {/* Tooltip Button */}
        <Box
          component="button"
          sx={styles.tooltipButton}
          onClick={handleClick}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          aria-label="Milk Reception position tooltip"
        >
          3
        </Box>

        {/* Tooltip Content */}
        <Popper
          open={open}
          anchorEl={anchorEl}
          placement="right-start"
          transition
          modifiers={[
            {
              name: 'offset',
              options: {
                offset: [0, 10],
              },
            },
          ]}
        >
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={200}>
              <Paper sx={styles.tooltipContent}>
                {/* Tooltip Image Container */}
                <Box sx={styles.tooltipImageContainer}>
                  <Box
                    component="img"
                    src={Thermization} 
                    alt="Milk cooler equipment" 
                    sx={styles.tooltipImage}
                  />
                </Box>

                {/* Tooltip Text Content */}
                <Box sx={styles.tooltipTextContent}>
                <Typography variant="h6" sx={styles.tooltipTitle}>
                    3. Lorem ipsum
                  </Typography>
                  <Typography variant="body2" sx={styles.tooltipParagraph}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.
                  </Typography>
                </Box>
              </Paper>
            </Fade>
          )}
        </Popper>
      </Box>
    </ClickAwayListener>
  );
};

export default Tooltip3; 